@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

.modalHeader {
	background-color: Colors.$col-greyBackground;
	color: Colors.$col-greyInactive;
	font-size: Constants.$val-fontSizeBig;
	font-weight: bold;
	display: flex; 

	.userName {
		color: Colors.$col-black;
		margin-left: Constants.$val-spacing-xs;
	}
}

.inheritedBodyProps {
	padding: 0 !important;
}

.modalBody {
	display: flex;
	flex-direction: column;
	align-items: stretch;

	.modalAlert {
		font-size: Constants.$val-fontSizeRegular;
		padding: Constants.$val-spacing-l;
		background-color: Colors.$col-greyInactive;
		color: Colors.$col-white;
		white-space: pre-line;
		line-height: Constants.$val-lineHeightRegular;
	}

	.timeCard {
		margin: Constants.$val-spacing-m Constants.$val-spacing-xxl;
		box-shadow: 0 2px 2px 0 Colors.$col-shadow;
	
		.timeCardHeader {
			justify-content: space-between;
			display: flex;
			flex-direction: row;
			font-size: Constants.$val-fontSizeXBig;
			padding: Constants.$val-headerHeightS;

			.headerIcon {
				width: Constants.$val-icon15;
				flex: 1;
				align-self: center;
				
				& [class^="icon-acceligent"] {
					font-size: Constants.$val-icon24;
					margin-right: Constants.$val-spacing-xxs;
				}
			};

			.timeCardName {
				flex: 9;
				align-self: flex-start
			}
		
			.headerSettingsIcon {
				flex: 1;
				align-self: flex-end;
			}
		} 

		.timeCardEntriesAlert {
			background-color: Colors.$col-canceledRed;
			color: Colors.$col-white;
			font-size: Constants.$val-fontSizeRegular;
			padding: Constants.$val-spacing-s;
			margin-bottom: Constants.$val-spacing-xxxs;
		}
		.timeCardEntriesWarning {
			background-color: Colors.$col-orange;
			color: Colors.$col-white;
			font-size: Constants.$val-fontSizeRegular;
			padding: Constants.$val-spacing-m;
			margin-bottom: Constants.$val-spacing-xxxs;
		}
	}

	.timeCardDay{	
		.timeCardDate {
			padding: Constants.$val-spacing-m;
			background-color: Colors.$col-design-grey12;
			color: Colors.$col-greyInactive;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
		}

		.totalTimeGeneral {
			background-color: Colors.$col-darkBlueBorder;
			display: flex;
			flex-direction: column;
			font-size: Constants.$val-fontSizeSmall;
			justify-content: space-between;
			color: Colors.$col-white;

			.firstRow {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: flex-start;
				padding: Constants.$val-spacing-s Constants.$val-spacing-m Constants.$val-spacing-s;

				.time {
					font-size: Constants.$val-fontSizeRegular;
					font-weight: bold;
				}
			}
			.secondRow {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				padding: 0 Constants.$val-spacing-m Constants.$val-spacing-s;

				.iconAndTime {
					display: flex;
					align-items: normal;
				}

				& [class^="icon-"] {
					font-size: Constants.$val-fontSizeBig;
					margin-right: Constants.$val-spacing-xxs;
				}
			}
		}

		.emptyEntryRow {
			padding: Constants.$val-headerHeightS;
		}

		.connectorTop {
			margin-left: 3.5%;
			width: Constants.$val-spacing-xxxs;
			height: Constants.$val-spacing-s;
			background-color: Colors.$col-greyConnection;
		};

		.connectorTopWarn {
			margin-left: 3.5%;
			width: Constants.$val-spacing-xxxs;
			height: Constants.$val-spacing-s;
			background-color: Colors.$col-canceledRed;
		};

		.connectorBottom {
			margin-left: 3.5%;
			width: Constants.$val-spacing-xxxs;
			height: Constants.$val-spacing-s;
			background-color: Colors.$col-greyConnection;
		}

		.connectorBottomWarn {
			margin-left: 3.5%;
			width: Constants.$val-spacing-xxxs;
			height: Constants.$val-spacing-s;
			background-color: Colors.$col-canceledRed;
		}

		.timeSheetEntry {
			display: flex;
			flex-direction: row;
			padding: Constants.$val-spacing-s;

			.workTypeIcon{
				flex: 0.5;
				align-self: center;
				color: Colors.$col-darkBlueBorder;
				display: flex;
				flex-direction: row;

				[class="icon-equipment"],
				[class="icon-travel"],
				[class="icon-home"],
				[class="icon-break"]  {
					font-size: Constants.$val-fontSizeXBig;
					position: relative;
				}
				
				.redIcon {
					color: Colors.$col-canceledRed;
				}

				.orangeIcon {
					color: Colors.$col-orange;
				}

				.inactiveIcon {
					color: Colors.$col-greyMid;
				}

				.greenIcon {
					color: Colors.$col-green;
				}

				// Positioning icon for indicating on-going entry
				[class="icon-time_card"]{
					font-size: Constants.$val-fontSizeSmall;
					color: Colors.$col-orange;
					position: absolute;
					left: 10.5%;
					transform: translate(50%, -50%);
  				}

				// Positioning icon for indicating rejected sheet
				[class="icon-x_circle"] {
					font-size: Constants.$val-fontSizeSmall;
					color: Colors.$col-canceledRed;
					position: absolute;
					left: 10.5%;
					transform: translate(50%, -50%);
  				}

				// Positioning icon for signed sheet
				[class="icon-check_circle"] {
					font-size: Constants.$val-fontSizeSmall;
					position: absolute;
					left: 10.5%;
					transform: translate(50%, -50%);
				}
			}

			.workTypeInfo{
				flex: 5;
				display: flex;
				flex-direction: column;

				.firstRow{
					display: flex;
					flex-direction: row;
					
					.workType {
						font-weight: bold;
						align-self: center;
					}

					.workOrderCode {
						margin-left: Constants.$val-spacing-s;
					}
					.unassigned {
						margin-left: Constants.$val-spacing-s;
						color: Colors.$col-canceledRed;
						font-size: Constants.$val-fontSizeSmall;
						align-self: center;
					}
				}

				.secondRow{
					display: flex;
					flex-direction: row;

					.overlapingTime {
						color: Colors.$col-canceledRed;
						font-size: Constants.$val-fontSizeSmall;
						padding: 0 Constants.$val-spacing-xxs;
					}

					.startEndTime {
						color: Colors.$col-greyInactive;
						font-size: Constants.$val-fontSizeSmall;
						padding: 0 Constants.$val-spacing-xxs;
					}
				}

				.workOrderCodeSeparator {
					margin-left: Constants.$val-spacing-s;
					border-left: 1px solid Colors.$col-greyFontLight;
  					height: auto;
				}
			}

			.workTypeDuration{
				flex: 1;
				font-weight: bold;
				display: flex;
				align-self: center;
				justify-content: center;
			}

			.workTypeEditIcon{
				flex: 0.5;
				display: flex;
				align-self: center;
				justify-content: center;
			}

			.activeTimer {
				color: Colors.$col-darkBlueBorder;
				font-weight: bold;
				display: flex;
				align-self: center;
				justify-content: center;
				font-size: Constants.$val-fontSizeBig;
			}
		}

		.gapRow{
			display: flex;
			flex-direction: row;
			align-items: normal;
			background-color: Colors.$col-orangeBorder;
			padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
			color: Colors.$col-white;
			font-size: Constants.$val-fontSizeSmall;
			margin: Constants.$val-spacing-s 0;

			& [class^="icon-"] {
				font-size: Constants.$val-fontSizeBig;
				margin-right: Constants.$val-spacing-xs;
			}
		}
	}

	.emptySpace {
		background-color: Colors.$col-greyBackground;
		height: Constants.$val-spacing-xl;
	}

	.footerButtons{
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
		align-self: center;
		align-items: center;
		padding: Constants.$val-spacing-s 0;
		
		
		.timeCardButton{
			padding: Constants.$val-spacing-m Constants.$val-spacing-xl;
			background-color: Colors.$col-white;
			font-weight: bold;
			align-content: center;
			border: 1px solid Colors.$col-design-gray5;
			border-radius: Constants.$val-button-borderRadius-l;
			color: Colors.$col-black
		}

		.statusIcon {
			font-size: Constants.$val-fontSizeRegular;
			margin-right: Constants.$val-spacing-s;
		}

		.signTCButton {
			padding: Constants.$val-spacing-m;
			font-weight: bold;
			background-color: Colors.$col-orange;
			color: Colors.$col-white;
			align-content: center;
			border: 1px solid;
			border-radius: Constants.$val-button-borderRadius-l;
		}

		.signedButton {
			padding: Constants.$val-spacing-s;
			background-color: Colors.$col-blue;
			color: Colors.$col-white;
			align-content: center;
			border: 1px solid;
			border-radius: Constants.$val-button-borderRadius-l;
		}
		
		.signedButtonRightPositioned {
			padding: Constants.$val-spacing-s;
			background-color: Colors.$col-blue;
			color: Colors.$col-white;
			border: 1px solid;
			border-radius: Constants.$val-button-borderRadius-l;
		}
	}

}

.linkText {
	color: Colors.$col-design-blue500;
}

.noEntriesToShow {
	padding: Constants.$val-spacing-xl;
	font-size: Constants.$val-fontSizeRegular;
	align-self: center;
	color: Colors.$col-greyInactive;
}

.timeCard {
	margin: Constants.$val-spacing-m Constants.$val-spacing-xxl;
	box-shadow: 0 2px 2px 0 Colors.$col-shadow;
	background-color: Colors.$col-white;

	.timeCardHeader {
		justify-content: space-between;
		display: flex;
		flex-direction: row;
		font-size: Constants.$val-fontSizeXBig;
		padding: Constants.$val-headerHeightS;
		
		.headerIcon {
			width: Constants.$val-icon15;
			flex: 1;
			align-self: center;

			& [class^="icon-acceligent"] {
				font-size: Constants.$val-icon24;
				margin-right: Constants.$val-spacing-xxs;
			}
		}

		.timeCardName {
			flex: 9;
			align-self: flex-start
		}
	
		.headerSettingsIcon {
			flex: 1;
			align-self: flex-end;
		}
	} 

	.timeCardEntriesAlert {
		background-color: Colors.$col-canceledRed;
		color: Colors.$col-white;
		font-size: Constants.$val-fontSizeRegular;
		padding: Constants.$val-spacing-s;
		margin-bottom: Constants.$val-spacing-xxxs;
	}
	.timeCardEntriesWarning {
		background-color: Colors.$col-orange;
		color: Colors.$col-white;
		font-size: Constants.$val-fontSizeRegular;
		padding: Constants.$val-spacing-m;
		margin-bottom: Constants.$val-spacing-xxxs;
	}
}

.timeCardDay{	
	.timeCardDate {
		padding: Constants.$val-spacing-m;
		background-color: Colors.$col-design-grey12;
		color: Colors.$col-greyInactive;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.totalTimeGeneral {
		background-color: Colors.$col-darkBlueBorder;
		display: flex;
		flex-direction: column;
		font-size: Constants.$val-fontSizeSmall;
		justify-content: space-between;
		color: Colors.$col-white;

		.firstRow {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: flex-start;
			padding: Constants.$val-spacing-s Constants.$val-spacing-m Constants.$val-spacing-s;

			.time {
				font-size: Constants.$val-fontSizeRegular;
				font-weight: bold;
			}
		}
		.secondRow {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			padding: 0 Constants.$val-spacing-m Constants.$val-spacing-s;

			.iconAndTime {
				display: flex;
				align-items: normal;
			}

			& [class^="icon-"] {
				font-size: Constants.$val-fontSizeBig;
				margin-right: Constants.$val-spacing-xxs;
			}
		}
	}

	.emptyEntryRow {
		padding: Constants.$val-headerHeightS;
	}

	.connectorTop {
		margin-left: 3.5%;
		width: Constants.$val-spacing-xxxs;
		height: Constants.$val-spacing-s;
		background-color: Colors.$col-greyConnection;
	};

	.connectorTopWarn {
		margin-left: 3.5%;
		width: Constants.$val-spacing-xxxs;
		height: Constants.$val-spacing-s;
		background-color: Colors.$col-canceledRed;
	};

	.connectorBottom {
		margin-left: 3.5%;
		width: Constants.$val-spacing-xxxs;
		height: Constants.$val-spacing-s;
		background-color: Colors.$col-greyConnection;
	}

	.connectorBottomWarn {
		margin-left: 3.5%;
		width: Constants.$val-spacing-xxxs;
		height: Constants.$val-spacing-s;
		background-color: Colors.$col-canceledRed;
	}

	.timeSheetEntry {
		display: flex;
		flex-direction: row;
		padding: Constants.$val-spacing-s;

	.workTypeIcon {
		flex: 0.5;
		align-self: center;
		color: Colors.$col-darkBlueBorder;
		display: flex;
		flex-direction: row;
		position: relative;
		
		[class="icon-equipment"],
		[class="icon-travel"],
		[class="icon-home"],
		[class="icon-break"] {
			font-size: Constants.$val-fontSizeXBig;
			position: relative;
		}
		
		.redIcon {
			color: Colors.$col-canceledRed;
		}
		
		.orangeIcon {
			color: Colors.$col-orange;
		}
		
		.inactiveIcon {
			color: Colors.$col-greyMid;
		}
		
		.greenIcon {
			color: Colors.$col-green;
		}

		// Positioning icon for indicating on-going entry
		[class="icon-time_card"]{
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-orange;
			position: absolute;
			top: 0;
			right: 45%;
			transform: translate(50%, -50%);
		}
		// Positioning icon for indicating rejected sheet
		[class="icon-x_circle"] {
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-canceledRed;
			position: absolute;
			top: 0;
			right: 45%;
			transform: translate(50%, -50%);
		}
		// Positioning icon for signed sheet
		[class="icon-check_circle"] {
			font-size: Constants.$val-fontSizeSmall;
			position: absolute;
			top: 0;
			right: 45%;
			transform: translate(50%, -50%);
		}
	}

	.workTypeInfo{
		flex: 5;
		display: flex;
		flex-direction: column;

		.firstRow{
			display: flex;
			flex-direction: row;
			
			.workType {
				font-weight: bold;
				align-self: center;
			}

			.workOrderCode {
				margin-left: Constants.$val-spacing-s;
			}
			.unassigned {
				margin-left: Constants.$val-spacing-s;
				color: Colors.$col-canceledRed;
				font-size: Constants.$val-fontSizeSmall;
				align-self: center;
			}
		}

		.secondRow{
			display: flex;
			flex-direction: row;

			.overlapingTime {
				color: Colors.$col-canceledRed;
				font-size: Constants.$val-fontSizeSmall;
				padding: 0 Constants.$val-spacing-xxs;
			}

			.startEndTime {
				color: Colors.$col-greyInactive;
				font-size: Constants.$val-fontSizeSmall;
				padding: 0 Constants.$val-spacing-xxs;
			}
		}

		.workOrderCodeSeparator {
			margin-left: Constants.$val-spacing-s;
			border-left: 1px solid Colors.$col-greyFontLight;
				height: auto;
		}
	}

	.workTypeDuration{
		flex: 1;
		font-weight: bold;
		display: flex;
		align-self: center;
		justify-content: center;
	}

	.workTypeEditIcon{
		flex: 0.5;
		display: flex;
		align-self: center;
		justify-content: center;
	}

	.activeTimer {
		color: Colors.$col-darkBlueBorder;
		font-weight: bold;
		display: flex;
		align-self: center;
		justify-content: center;
		font-size: Constants.$val-fontSizeBig;
	}
}

	.gapRow{
		display: flex;
		flex-direction: row;
		align-items: normal;
		background-color: Colors.$col-orangeBorder;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
		color: Colors.$col-white;
		font-size: Constants.$val-fontSizeSmall;
		margin: Constants.$val-spacing-s 0;

		& [class^="icon-"] {
			font-size: Constants.$val-fontSizeBig;
			margin-right: Constants.$val-spacing-xs;
		}
	}
}

.emptySpace {
	background-color: Colors.$col-greyBackground;
	height: Constants.$val-spacing-xl;
}

	.footerButtons{
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
		align-self: center;
		align-items: center;
		padding: Constants.$val-spacing-s 0;
		
		
		.timeCardButton{
			padding: Constants.$val-spacing-m Constants.$val-spacing-xl;
			background-color: Colors.$col-white;
			font-weight: bold;
			align-content: center;
			border: 1px solid Colors.$col-design-gray5;
			border-radius: Constants.$val-button-borderRadius-l;
			color: Colors.$col-black
		}

		.statusIcon {
			font-size: Constants.$val-fontSizeRegular;
			margin-right: Constants.$val-spacing-s;
		}

		.signTCButton {
			padding: Constants.$val-spacing-m;
			font-weight: bold;
			background-color: Colors.$col-orange;
			color: Colors.$col-white;
			align-content: center;
			border: 1px solid;
			border-radius: Constants.$val-button-borderRadius-l;
		}

		.signedButton {
			padding: Constants.$val-spacing-s;
			background-color: Colors.$col-blue;
			color: Colors.$col-white;
			align-content: center;
			border: 1px solid;
			border-radius: Constants.$val-button-borderRadius-l;
		}
		
		.signedButtonRightPositioned {
			padding: Constants.$val-spacing-s;
			background-color: Colors.$col-blue;
			color: Colors.$col-white;
			border: 1px solid;
			border-radius: Constants.$val-button-borderRadius-l;
		}
	}
